import React, { useEffect } from "react";
import {
  Building2,
  Hammer,
  Home,
  Wrench,
  Palette,
  Droplets,
} from "lucide-react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Services() {
  // useEffect(() => {
  //   AOS.init({ duration: 1000, once: true });
  // }, []);

  const services = [
    {
      icon: <Building2 className="h-8 w-8" />,
      title: "Building Renovation",
      description:
        "Complete renovation services for residential and commercial buildings",
      href: "/services/building-renovation",
    },
    {
      icon: <Hammer className="h-8 w-8" />,
      title: "Civil Contract",
      description: "Professional civil engineering and construction contracts",
      href: "/services/civil-contract",
    },
    {
      icon: <Home className="h-8 w-8" />,
      title: "Architecture",
      description: "Innovative architectural design and planning services",
      href: "/services/architecture",
    },
    {
      icon: <Palette className="h-8 w-8" />,
      title: "Interior Design",
      description: "Modern and functional interior design solutions",
      href: "/services/interior-design",
    },
    {
      icon: <Wrench className="h-8 w-8" />,
      title: "Tiles Installation",
      description: "Professional tile installation for all surfaces",
      href: "/services/tiles-installation",
    },
    {
      icon: <Droplets className="h-8 w-8" />,
      title: "Plumbing",
      description: "Complete plumbing solutions and maintenance services",
      href: "/services/plumbing",
    },
  ];

  return (
    <div className="min-h-screen overflow-hidden">
      {/* Services Overview */}
      <section className="py-20 bg-gray-50" data-aos="fade-up">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We offer comprehensive construction and real estate services to
              meet all your needs
            </p>
          </div> */}
          <div className="mb-16 text-center" data-aos="fade-up">
            <div className="inline-block text-left">
              <h2 className="text-4xl font-bold text-[#1F36FE] mb-1">
                Our Services
              </h2>
              <div
                className="w-20 h-1 bg-[#6FEF34]  mx-auto blink-underline blink-underline"
                style={{ width: "120px" }}
              ></div>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mt-4 mx-auto">
              We offer comprehensive construction and real estate services to
              meet all your needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="border bg-white p-6 rounded-lg hover:shadow-lg transition-shadow duration-300"
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <div className="text-[#6FEF34] mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-2 text-blue-700">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <Link
                  to={service.href}
                  className="inline-block border border-gray-300 px-4 py-2 rounded hover:bg-gray-100 transition"
                >
                  Learn More
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white" data-aos="fade-up">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-blue-700 mb-4">
              Why Choose Sanctus property pvt ltd?
            </h2>

            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We stand out in the construction and real estate industry through
              our commitment to excellence
            </p>
          </div> */}
          <div className="text-center mb-16" data-aos="fade-up">
            <div className="inline-block">
              <h2 className="text-4xl font-bold text-blue-700 mb-1">
                Why Choose Sanctus property pvt ltd?
              </h2>
              <div className="h-1 bg-[#6FEF34] mx-auto w-[220px] md:w-[490px] blink-underline"></div>
            </div>

            <p className="text-xl text-gray-600 max-w-3xl mx-auto mt-4">
              We stand out in the construction and real estate industry through
              our commitment to excellence
            </p>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: "Years Experience",
                stat: "15+",
                desc: "Over a decade of proven expertise in construction and real estate",
              },
              {
                title: "Projects Completed",
                stat: "500+",
                desc: "Successfully delivered projects across residential and commercial sectors",
              },
              {
                title: "Support Available",
                stat: "24/7",
                desc: "Round-the-clock customer support and emergency services",
              },
              {
                title: "Quality Guaranteed",
                stat: "100%",
                desc: "We stand behind our work with comprehensive warranties",
              },
            ].map((item, idx) => (
              <div
                className="text-center"
                key={idx}
                data-aos="fade-up"
                data-aos-delay={idx * 150}
              >
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-blue-600">
                    {item.stat}
                  </span>
                </div>
                <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div> */}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: "Years Experience",
                stat: "15+",
                desc: "Over a decade of proven expertise in construction and real estate",
              },
              {
                title: "Projects Completed",
                stat: "500+",
                desc: "Successfully delivered projects across residential and commercial sectors",
              },
              {
                title: "Support Available",
                stat: "24/7",
                desc: "Round-the-clock customer support and emergency services",
              },
              {
                title: "Quality Guaranteed",
                stat: "100%",
                desc: "We stand behind our work with comprehensive warranties",
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="text-center bg-blue-50 border border-blue-200 rounded-xl p-6 hover:bg-blue-100 hover:shadow-lg transition-all duration-300"
                data-aos="fade-up"
                data-aos-delay={idx * 150}
              >
                <div className="bg-blue-200 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-blue-700">
                    {item.stat}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-blue-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gray-50" data-aos="fade-up">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              What Our Clients Say
            </h2>
            <p className="text-xl text-gray-600">
              Don't just take our word for it - hear from our satisfied
              customers
            </p>
          </div> */}
          <div className="text-center mb-16" data-aos="fade-up">
            <div className="inline-block">
              <h2 className="text-4xl font-bold text-blue-700 mb-1">
                What Our Clients Say
              </h2>
              <div
                className="w-20 h-1 bg-[#6FEF34] mx-auto blink-underline"
                style={{ width: "190px" }}
              ></div>
            </div>
            <p className="text-xl text-gray-600 mt-4">
              Don't just take our word for it - hear from our satisfied
              customers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: "Sarah Johnson",
                role: "Homeowner",
                quote:
                  "Sanctus property pvt ltd transformed our outdated kitchen into a modern masterpiece. Their attention to detail and professionalism exceeded our expectations.",
              },
              {
                name: "Michael Chen",
                role: "Business Owner",
                quote:
                  "The commercial renovation of our office space was completed on time and within budget. Highly recommend Sanctus property pvt ltd for any construction needs.",
              },
              {
                name: "Emily Rodriguez",
                role: "Property Developer",
                quote:
                  "Working with Sanctus property pvt ltd on our residential development project was seamless. Their expertise in real estate construction is unmatched.",
              },
            ].map((client, idx) => (
              <div
                key={idx}
                className="border p-6 rounded-lg bg-white"
                data-aos="flip-left"
                data-aos-delay={idx * 150}
              >
                <div className="flex items-center mb-4">
                  <img
                    src="https://i.pinimg.com/736x/e5/a6/9f/e5a69fc91a99ecdbdcf348e03601e95a.jpg"
                    alt="Client"
                    className="w-12 h-12 rounded-full mr-4"
                  />
                  <div>
                    <h4 className="font-semibold">{client.name}</h4>
                    <p className="text-gray-600 text-sm">{client.role}</p>
                  </div>
                </div>
                <p className="text-gray-600 italic">"{client.quote}"</p>
                <div className="flex text-yellow-400 mt-4">★★★★★</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Recent Projects Preview */}
      <section className="py-20 bg-white" data-aos="fade-up">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Recent Projects
            </h2>
            <p className="text-xl text-gray-600">
              Take a look at some of our latest completed projects
            </p>
          </div> */}
          <div className="text-center mb-16">
            <div className="inline-block">
              <h2 className="text-4xl font-bold text-blue-700 mb-1">
                Recent Projects
              </h2>
              <div
                className="w-20 h-1 bg-[#6FEF34] mx-auto blink-underline"
                style={{ width: "120px" }}
              ></div>
            </div>
            <p className="text-xl text-gray-600 mt-4">
              Take a look at some of our latest completed projects
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {[
              {
                title: "Luxury Villa Construction",
                desc: "Modern 4-bedroom villa with premium finishes",
                img: "https://i.pinimg.com/736x/b6/67/ce/b667ce59f5c31b08ae1c48322108a34f.jpg",
              },
              {
                title: "Corporate Office Renovation",
                desc: "Complete renovation of 10-story office building",
                img: "https://i.pinimg.com/736x/97/27/cf/9727cf5bd1b8c0b25c1f2bea77834267.jpg",
              },
              {
                title: "Residential Complex",
                desc: "50-unit modern residential development",
                img: "https://i.pinimg.com/736x/d9/09/00/d909003ddbe74c5efd1cbcd672c85471.jpg",
              },
            ].map((proj, idx) => (
              <div
                key={idx}
                className="relative group overflow-hidden rounded-lg"
                data-aos="zoom-in-up"
                data-aos-delay={idx * 150}
              >
                <img
                  src={proj.img}
                  alt={proj.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition-all duration-300 flex items-end">
                  <div className="p-6 text-white">
                    <h3 className="text-xl font-semibold mb-2">{proj.title}</h3>
                    <p className="text-sm">{proj.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center" data-aos="fade-up">
            <Link
              to="/projects"
              className="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition"
            >
              View All Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-blue-600" data-aos="zoom-in">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Contact us today for a free consultation and quote
          </p>
          <Link
            to="/contact"
            className="inline-block px-6 py-3 bg-[#6FEF34] text-blue-600 font-semibold rounded hover:bg-gray-100 transition"
          >
            Contact Us Now
          </Link>
        </div>
      </section>
    </div>
  );
}
